import { FooterLinkType } from 'mtv-mswap-uikitty'
import { ContextApi } from 'contexts/Localization/types'

export const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
]
